import { ApplicationVisibilityVoData } from "../../vo/application/application-visibility-vo-data";
var ApplicationConverter = /** @class */ (function () {
    function ApplicationConverter() {
    }
    ApplicationConverter.convertToApplicationVivibilityVoData = function (applicationVisibilityAPIData) {
        var applicationVo = new ApplicationVisibilityVoData(applicationVisibilityAPIData.viewAllItems);
        applicationVo.viewProjectManagement = applicationVisibilityAPIData.viewProjectManagement;
        applicationVo.viewProductManagement = applicationVisibilityAPIData.viewProductManagement;
        applicationVo.viewFeedbackManagement = applicationVisibilityAPIData.viewFeedbackManagement;
        applicationVo.viewWork = applicationVisibilityAPIData.viewWork;
        applicationVo.viewDashboard = applicationVisibilityAPIData.viewDashboard;
        applicationVo.viewUsers = applicationVisibilityAPIData.viewUsers;
        applicationVo.viewCustomers = applicationVisibilityAPIData.viewCustomers;
        applicationVo.viewContainers = applicationVisibilityAPIData.viewContainers;
        applicationVo.viewActivities = applicationVisibilityAPIData.viewActivities;
        applicationVo.viewCommunication = applicationVisibilityAPIData.viewCommunication;
        return applicationVo;
    };
    return ApplicationConverter;
}());
export { ApplicationConverter };
//# sourceMappingURL=application-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/application-converter.js
// module id = 965
// module chunks = 14